import { EncryptionPackage } from "@civic/lexi/dist/lib/encrypt";
import { ContentItemInternal } from "./types";

export function encryptionPackageFromContentItemInternal(contentItem: ContentItemInternal): EncryptionPackage {
    const encryptionMetadata =
        typeof contentItem.encryptionMetadata === 'string' ?
        JSON.parse(contentItem.encryptionMetadata) :
        contentItem.encryptionMetadata;
    return encryptionMetadata as EncryptionPackage;
}
